import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardComponent } from '@ng-cds/ui-components/card';
import { ButtonComponent } from '@ng-cds/ui-components/button';
import {
  ApiResponse,
  AuthService,
  AuthURLResponse,
  FeatureFlagService,
  UserMeResponse,
  UserService,
} from '@vallia-doc-flow/ui-auth';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginToasterMessage } from './login.utils';
import { shouldCheckAuditAssist, shouldCheckOFAC, shouldCheckTestModel } from '../../components/left-menu/menu.utils';
@Component({
  selector: 'vallia-doc-flow-login',
  standalone: true,
  imports: [CommonModule, CardComponent, ButtonComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  isButtonDisabled = false;
  logoSrc = '../../../assets/img/doc-flow.svg';
  footerText = `Vallia DocFlow is a product by Brimma Tech Inc.<br>© ${new Date().getFullYear()} Brimma Tech Inc. All Rights Reserved.`;

  private authService = inject(AuthService);
  private featureService = inject(FeatureFlagService);
  private userService = inject(UserService);
  private toasterService = inject(ToastrService);

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private navigationType = {
    suAdmin: '/admin',
    user: '/user',
    'tenant-admin': '/user',
  };

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      this.authService.refreshToken.next(token);
      if (this.authService.refreshToken.value || token) {
        sessionStorage.setItem('authToken', token);
        this.isButtonDisabled = true;
        this.userService.getValliaUserDetails().subscribe({
          next: (userDetails: ApiResponse<UserMeResponse>) => {
            if (userDetails) {
              const { role, tenantId, clientId, applicationId, userId } = userDetails.data;
              sessionStorage.setItem('userDetails', JSON.stringify(userDetails.data));

              this.featureService.getFeatureFlags(tenantId, clientId, applicationId, userId).subscribe({
                next: () => {
                  const isTestModelEnabled = shouldCheckTestModel(this.featureService);
                  const isAuditAssistEnabled = shouldCheckAuditAssist(this.featureService);
                  const isOFACAnalysisEnabled = shouldCheckOFAC(this.featureService);

                  if (isTestModelEnabled || isAuditAssistEnabled || isOFACAnalysisEnabled) {
                    this.router.navigate(['/playground']);
                  } else {
                    this.router.navigate([this.navigationType[role]]);
                  }
                },
                error: () => {
                  this.isButtonDisabled = false;
                  this.toasterService.error(LoginToasterMessage.roleFailedMessage());
                },
              });
            } else {
              this.isButtonDisabled = false;
              this.toasterService.error(LoginToasterMessage.roleFailedMessage());
            }
          },
          error: () => {
            this.isButtonDisabled = false;
            this.toasterService.error(LoginToasterMessage.roleFailedMessage());
          },
        });
      }
    });
  }

  login(): void {
    sessionStorage.clear();
    this.isButtonDisabled = true;
    this.authService.getSSOLoginUrl().subscribe({
      next: (response: AuthURLResponse) => {
        window.location.href = response.data;
      },
      error: () => {
        this.isButtonDisabled = false;
        this.toasterService.error(LoginToasterMessage.loginFailedMessage());
      },
    });
  }
}
